import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

import { CanvasToolbarIconComponent } from '../../../icons/canvas-toolbar-icon.component';

@Component({
  selector: 'lib-canvas-draw-circle-tool',
  standalone: true,
  imports: [CanvasToolbarIconComponent],
  template: `
    <button
      type="button"
      class="cv-tb__btn"
      [class.cv-tb__btn--add-point-active]="active"
      [attr.aria-pressed]="active"
      (click)="draw.emit()"
      title="Add point"
    >
      <lib-canvas-toolbar-icon name="add-location"></lib-canvas-toolbar-icon>
    </button>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class DrawCircleToolComponent {
  @Input() active = false;
  @Output() draw = new EventEmitter<void>();
}
